import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-5 py-16 text-center">
      <p className="text-xs font-bold uppercase tracking-[0.28em] text-salt-gold/80">Lost</p>
      <h1 className="salt-display-mega mt-4 text-white/15">404</h1>
      <h2 className="mt-2 font-display text-2xl font-semibold text-white sm:text-3xl">
        Page not found
      </h2>
      <p className="mt-3 max-w-md text-sm text-white/45">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-bold text-white transition hover:border-salt-gold/40"
        >
          <ArrowLeft className="h-4 w-4" />
          Go back
        </button>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="salt-cta-mega !py-2.5 !px-6 !text-sm"
        >
          <Home className="h-4 w-4" />
          Home
        </button>
      </div>

      <div className="mt-12 border-t border-white/8 pt-8">
        <p className="mb-4 text-xs font-bold uppercase tracking-wider text-white/30">Popular</p>
        <div className="flex flex-wrap justify-center gap-2">
          {[
            { label: 'Groups', path: '/groups' },
            { label: 'Today', path: '/tasks?filter=today' },
            { label: 'Curriculum', path: '/curriculum' },
            { label: 'Messages', path: '/messages' },
          ].map(({ label, path }) => (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              className="rounded-full bg-white/6 px-4 py-2 text-sm font-bold text-white/55 transition hover:bg-white/10 hover:text-white"
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
